/* import __COLOCATED_TEMPLATE__ from './standard-body-header.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();